import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';

import { Translate } from '../../../i18n/i18n';
import { DiceValue, DiceValueEffect, DiceValueWrapper } from './DiceValue.styles';

export default ({dice, value, index, title, dices=[], expression, hidden}) => {

    const element = useRef(null);
    const effect = useRef(null);
    const isOwner = useSelector(state => state.authState.isOwner);

    const isCritical = useCallback(() => {
        if (hidden && !isOwner) {
            return false;
        }

        if (dices.length > 0) {
            return dices.some(d => {
                return d.criticalEach.every(a=>a);
            });
        }

        if (dice) {
            return dice.criticalEach ? Boolean(dice.criticalEach[index]) : false;
        }

        return false;
    }, [dice, index, dices, hidden, isOwner]);

    const isFail = useCallback(() => {
        if (hidden && !isOwner) {
            return false;
        }
        
        if (dices.length > 0) {
            return dices.some(d => {
                return d.failEach.every(a=>a);
            });
        }

        if (dice) {
            return dice.failEach ? Boolean(dice.failEach[index]) : false;
        }
    }, [dice, dices, index, hidden, isOwner]);

    const isIgnored = useCallback(() => {
        return dice && dice.ignored && dice.ignored.length && dice.ignored.indexOf(value[value.length - 1]) >= 0;
    }, [dice, value]);

    const getDiceClass = useMemo(() => {
        let classes = [];
        
        if (isCritical()) {
            classes.push('critical');
        }
        if (isFail()) {
            classes.push('fail');
        }
        if (isIgnored()) {
            classes.push('ignored');
        }

        if (hidden && !isOwner) {
            classes.push('hiddenroll');
        }

        return classes;
    }, [isCritical, isFail, isIgnored, hidden, isOwner]);

    useEffect(() => {
        let random = Array(60).fill(0)
        
        if (dice.sides === 'F') {
            random = random.map(i => Math.ceil(Math.random() * 3) - 2);
        } else {
            random = random.map(i => Math.ceil(Math.random() * dice.sides));
        }

        let index = 0;
        let delay = 16;

        random = [...random, ...value];

        if (dice.sides === 'F') {
            random = random.map(val => val >= 0 ? ("+"+String(val)) : String(val));
        }

        const renderValue = (dice) => {
            index = index < 69 ? (index+1) : 0;
            delay = index < 59 ? 16 : 50+((index-60)*40);
            element.current.innerHTML = random[index];

            if (index < 69) {
                setTimeout(()=>renderValue(dice), delay);
            } else {
                effect.current.classList.add('shown');

                if (!isOwner && hidden) {
                    element.current.innerHTML = 'X';
                }
                
                if (title) {
                    let attrTitle = (expression ? `(${expression}): ` : '');
                    if (!hidden) {
                        attrTitle += title;
                    } else {
                        attrTitle += isOwner ? ('#X '+title) : Translate('chat.hidden');
                    }

                    element.current.setAttribute('title', attrTitle);
                }

                for(let c of getDiceClass) {
                    element.current.classList.add(c);
                    effect.current.classList.add(c);
                }

                setTimeout(() => {
                    effect.current.classList.remove('shown');
                    effect.current.classList.add('hidden');
                }, 1000);
            }

            return null;
        };

        setTimeout(()=>renderValue(dice), delay);

    }, [dice, value, title, expression, getDiceClass, hidden, isOwner]);

    return <DiceValueWrapper>
        <DiceValue className={dice.sides === 'F' ? 'fateDice' : ''} sides={dice.sides || 100} ref={element} />
        <DiceValueEffect ref={effect}>{!isOwner && hidden ? 'X' : value[value.length - 1]}</DiceValueEffect>
    </DiceValueWrapper>

};